/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext } from 'react';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FileContainer, FileHeader, ContPages, Actions, File, FileContent, TitleContainer, DocumentName } from './styles';
import Icon from 'components/Icon';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import PropTypes from 'prop-types';

const propTypes = {
  file: PropTypes.any
}

export default function FileModal({ file, actions = true, idOperation, summary }, ...props) {
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);

  const [numDocuments, setNumDocuments] = useState(0);
  const [index, setIndex] = useState(0);
  const [isArray, setIsArray] = useState(false);

  function printDiv() {
    // seta o source no iframe
    if (file[index].lnkAccessPdf) {
      var iframe = document.getElementById("pdf");
      iframe.src = file[index].lnkAccessPdf;
    }

    // versão rodrigo
    /* var divContents = document.getElementById("file").innerHTML;
     var modalPrint = window.open('', '');
     modalPrint.document.write(divContents);
     modalPrint.document.close();
     modalPrint.print();
     modalPrint.onafterprint = function(){
         modalPrint.window.close()
     }*/


    // --------- original
    /*
        var printContents = document.getElementById("file").innerHTML;
        var originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        document.body.innerHTML = originalContents;
    */
    //-------------------


    /*
        var doc = document.getElementById("file");

         //Wait until PDF is ready to print
         if (typeof doc.print === 'undefined') {
             setTimeout(function(){printDocument("file");}, 1000);
         } else {
             doc.print();
         } */
    /* doc.html(file.toString());
    doc.save();
    console.log("arquivo HTMLAllCollection", file)
    doc.html(file, {
        callback: function (doc) {
            doc.save();
        }
    });
*/
  };

  //----- rodrigo ------
  function printContent() {
    const iframe = document.createElement('IFRAME');
    let doc = null;
    iframe.setAttribute('id', 'printPdf');
    iframe.setAttribute('style', 'textAlign:center; visibility: hidden');
    document.body.appendChild(iframe);
    doc = iframe.contentWindow.document;
    doc.write(file[index].title || file[index].html ? file[index].html : file[index]);
    doc.close();
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  }
  function printContentPdf() {
    console.log('iniciando função')
    const iframe = document.getElementById('pdf');
    if (iframe.getAttribute('src')) {
      console.log('carregando impressão')
      iframe.contentWindow.print();
    }
  }
  //--------------------

  function PrintElem() {
    var printContents = document.getElementById("file").innerHTML;
    Popup(printContents);
  }

  function Popup(data) {
    var myWindow = window.open('', 'file');
    myWindow.document.write(data);

    console.log(myWindow)

    /*setTimeout(() => { // Needed for large documents
        myWindow.document.body.style.margin = '0 0';
        myWindow.document.body.innerHTML = myWindow.outerHTML;
        myWindow.document.close(); // necessary for IE >= 10
        myWindow.focus(); // necessary for IE >= 10
        myWindow.print();
        myWindow.close();
    }, 1000)*/
  }

  function handlePrevious() {
    if (index === 0) {
      return;
    }
    setIndex(index - 1);
  };

  function handleNext() {
    if ((index + 1) < numDocuments) {
      setIndex(index + 1);
    }
    return;
  };

  function handleOpenfile() {
    if (file[index].lnkAccessPdf) {
      window.open(file[index].lnkAccessPdf, '_blank');
    }
    return;
  };

  const handleDownloadAllFiles = () => {
    loading.start();

    fitinsur.setAuthToken(authContext.token);

    let fileName = "";
    fitinsur.requestDownloadAllFiles(file, idOperation)
      .then(response => {
        if (response.status !== 200) {
          loading.stop();
          throw new Error();
        }

        return response.blob().then((data) => {
          return {
            data: data,
            fileNameHeader: response.headers.get('Content-Disposition'),
          };
        });
      }).then(({ data, fileNameHeader }) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');

        fileName = fileNameHeader.split('filename=')[1].split('.')[0];

        a.style.display = 'none';
        a.href = url;
        a.download = fileName || 'extracted-files.zip';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        loading.stop();
      }).catch(err => {
        console.log('error', err)
        loading.stop();
      });
  }

  useEffect(() => {
    if (Array.isArray(file)) {
      setNumDocuments(file?.length);
      setIsArray(true);

    } else {
      setNumDocuments(1);
    }

  }, [file]);

  return (
    <FileContainer>
      {!file || (file.length === 0) ? "" :
        <>
          <FileHeader>
            <TitleContainer>
              <DocumentName>{file[index]?.title ? file[index].title : "File Name"}</DocumentName>
              <ContPages>
                <Icon onClick={() => handlePrevious()} name={index === 0 ? "arrowLeftFade" : "arrowLeftWhite"} style={{ marginRight: "10px" }} />
                Document {index < numDocuments ? index + 1 : index} of {numDocuments/*file?.length*/}
                <Icon onClick={() => handleNext()} name={(index + 1) < numDocuments ? "arrowRightWhite" : "arrowRightFade"} style={{ marginLeft: "10px" }} />
              </ContPages>
            </TitleContainer>
            <Actions>
              {actions &&
                <>
                  <Icon
                    onClick={() => printDiv()}
                    name="print-white"
                    title="Print"
                  />
                  <Icon
                    onClick={() => handleOpenfile()}
                    name="downloadBlue"
                    title="Extract file"
                  />
                  {(file && file.length > 1) &&
                    <Icon
                      onClick={() => handleDownloadAllFiles()}
                      name="download-all-filesBlue"
                      title="Extract all files"
                    />
                  }
                </>
              }
            </Actions>
          </FileHeader>

          <FileContent>
            {isArray ?
              <File dangerouslySetInnerHTML={file[index]?.title || file[index].html ? { __html: file[index].html } : { __html: file[index] }} id="file" />
              :
              <File dangerouslySetInnerHTML={{ __html: file }} id="file" />
            }
          </FileContent>
          <iframe id={"pdf"} onLoad={() => printContentPdf()} style={{ display: 'none' }} />
        </>
      }
      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </FileContainer >
  )

}

FileModal.propType = propTypes;
